module.exports = __webpack_public_path__ + "img/engagement-mobile.2507860.jpg";